const DEFAULT_FEEDBACK_MESSAGE_DURATION = 2000
const FEEDBACK_MESSAGE_TYPES = ['success', 'warning', 'info', 'error']

function normalizeMessageOptions(options, type) {
  const normalized = typeof options === 'string'
    ? { message: options }
    : { ...(options || {}) }

  if (type) {
    normalized.type = type
  }
  if (typeof normalized.duration === 'undefined') {
    normalized.duration = DEFAULT_FEEDBACK_MESSAGE_DURATION
  }

  return normalized
}

function createFeedbackMessage(Message) {
  const feedbackMessage = options => Message(normalizeMessageOptions(options))

  FEEDBACK_MESSAGE_TYPES.forEach(type => {
    feedbackMessage[type] = options => Message(normalizeMessageOptions(options, type))
  })
  feedbackMessage.closeAll = () => Message.closeAll()

  return feedbackMessage
}

module.exports = {
  DEFAULT_FEEDBACK_MESSAGE_DURATION,
  createFeedbackMessage,
  normalizeMessageOptions
}
